import AbstractContext from '@/shared/models/AbstractContext';
import Booking from './Booking';

export default class BookingContext extends AbstractContext {
  constructor(
    readonly booking: Booking,
  ) {
    super();
  }
}